import { useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface FavoriteLocation {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  notes: string | null;
  created_at: string;
  display_name?: string;
  bortle_class?: number | null;
}

export const useFavoriteLocations = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { data: locations = [], isLoading } = useQuery({
    queryKey: ['favorite-locations', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('favorite_locations')
        .select('*')
        .eq('user_id', user!.id)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return (data || []) as FavoriteLocation[];
    },
    enabled: !!user,
    staleTime: 30_000, // Cache for 30s — avoids re-fetch on tab switch
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['favorite-locations', user?.id] });
  };

  return { locations, isLoading, invalidate };
};
